import script from "./UserFacturacionNuevo.vue?vue&type=script&setup=true&lang=js"
export * from "./UserFacturacionNuevo.vue?vue&type=script&setup=true&lang=js"

import "./UserFacturacionNuevo.vue?vue&type=style&index=0&id=5ca7758d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ca7758d"]])

export default __exports__